import { h } from "preact";

import {
    Typography,
    Paper,
    Button,
    Box,
} from "@mui/material";

export default function E404() {

    return (
        <Paper style="padding: 10px; margin: 20px;">
            <Typography variant="h5">La page que vous demandez n'est pas attribuée</Typography>
            <Typography variant="h5">Veuillez renouveller votre appel</Typography>
            <Button variant="contained" onClick={() => window.location.href = "/"}>Retourner à l'accueil</Button>
        </Paper>
    );
}
